module.exports = __webpack_public_path__ + "media/bootstrap-icons/reply-3949fb6b.svg";